
import React from 'react';
import { getServiceName } from '../../utils/consts';
import { NineCellLoading } from 'react-loadingg';
import Cookies from 'universal-cookie';
import checkSiteToken from '../../services/checkSiteToken';
import AccountHeader from '../../components/AccountHeader/AccountHeader';
import AccountSidebar from '../../components/AccountSidebar/AccountSidebar';

// Local
import img from '../../images/background_image.png';
import Constants from '../../utils/consts';
import DemoCreationWidget from '../../widgets/demoCreationWidget';
import getSiteUser from '../../services/getSiteUser';

// Styles 
import './style.css';
import './bootstrap.min.css';
import './owl.carousel.css';
import './owl.theme.css';
import './owl.transitions.css';
import './animate.css';
import './preloader.css';
import loginService from '../../services/login';
import translateString from '../../utils/Locales';
import Utils from '../../utils/utils';

const cookies = new Cookies();
var username = '';
var token = '';
var qs = require('querystring');
let t = translateString;

export default class AccountPage extends React.Component {

    constructor(props) {
        super(props);
    
        username = cookies.get('site_username', { path: '/' });
        token = cookies.get('site_token', { path: '/' });

        console.log(username, token);

        this.state = {
            isLoading: true, 
            menuItems: [], 
            showDemoDetails: false, 
            isDemoActive: false,
            cliente: null,
            endingSub: false,
        };
    }

    async componentDidMount() {
        document.title = getServiceName() + ' - Acount';
        Utils.setAnalyticsPage('Account creation');

        const res = await checkSiteToken(username, token);
        if (res == null) {
            cookies.set('site_username', '', { path: '/' });
            cookies.set('site_token', '', { path: '/' });
            window.location.href = '/#/main/login';
            return;
        } else {
            await this.load();
        }
    }

    async load() {
        this.setState({ isLoading: true });
        var user = cookies.get('site_username', { path: '/' });
        var t = cookies.get('site_token', { path: '/' });
        this.cliente = await getSiteUser(user, t);
        
        if (this.cliente.active == 0) {
            this.setState({ isLoading: false, cliente: this.cliente });
        } else {
            var db = this.cliente.db_name;
            cookies.set('db', db, { path: '/' });
            var username = this.cliente.username;
            var password = this.cliente.clear_password;

            const res = await loginService(username, password);
            if (res != null) {
                if (res.user != null) {
                    window.location.href =  db + '#/login?username=' + username + '&token=' + res.token;
                }
            } else {
                window.location.href = '/#/main/home';
            }
        }

        if (window.location.hash != '/#/main/account') {
            const parsed = qs.parse(window.location.hash);

            if (parsed['#/main/account?endSubscription'] == 'true') {
                this.setState({ showDemoDetails: true, endingSub: true });
            }
        }
    } 

    createDemo() {
        this.setState({ showDemoDetails: true, endingSub: false });
    }

    onCancelDemoCreation() {
        this.setState({ showDemoDetails: false });
    }

    render () {

        if (this.state.isLoading) return <NineCellLoading />

        return (
            <div>
                <>
                    <AccountHeader history={this.props.history} cliente={this.state.cliente} />
                    <AccountSidebar menuItems={this.state.menuItems} />
                    <div>
                        { !this.state.endingSub && (
                            <div style={demo}>
                                <div style={{maxWidth: '60%', flex: 1}}>
                                <p style={titleText}>{t('tua_demo')}</p>
                                    { this.state.isDemoActive ? (
                                        <p style={text}>Hai già attivato la tua demo e puoi accedervi all'indirizzo:<b> https://{ cookies.get('db', { path: '/' }) }.localhost:3000/ </b><br/>oppure cliccando sul pulsante qui a fianco.</p>
                                    ) : (
                                        <p style={text}>Sembra che tu non abbia ancora completato gli ultimi passaggi per poter attivare la tua demo gratuita di Hdemia per 30 giorni.<br/>Completa subito il tuo profilo cliccando sul pulsante qui a fianco.</p>
                                    )}
                                </div>
                                <div style={{maxWidth: '30%', marginLeft: '10%', flex: 1 }}>
                                    { this.state.isDemoActive ? (
                                        <div className="btn btn-primary" onClick={() => window.location.href = cookies.get('db', { path: '/' }) + Constants.basicUrl } style={{ position: 'absolute', right: 20, bottom: 20 }}>Vai alla demo</div>
                                    ) : (
                                        <div className="btn btn-primary" onClick={() => this.createDemo()} style={{ position: 'absolute', right: 20, bottom: 20 }}>Completa il profilo</div>
                                    )}
                                </div>
                            </div>
                        )}
                        { this.state.showDemoDetails && (
                            <DemoCreationWidget
                                databaseName = {cookies.get('db', { path: '/' })}
                                cliente = { this.state.cliente }
                                onCancel = {() => this.onCancelDemoCreation()}
                                endingSub = {this.state.endingSub}
                            />
                        )}
                    </div>
                </>
            </div>
        );
    }
}

const demo = {
    position: 'absolute', 
    left: 300, 
    right: 40, 
    top: 60,
    minHeight: 200,
    display: 'block',
    marginTop: 100, 
    backgroundImage: `url(${img})`,
    backgroundSize: '100% auto',
    backgroundRepeat: 'no-repeat',
    borderRadius: '10px', 
    border: '1px solid lightgrey', 
    boxShadow: '0px 2px 10px lightgrey',
    backgroundColor: '#B8BFE0',
    paddingLeft: '50px',
    paddingRight: '50px',
    paddingTop: '30px',
    paddingBottom: '30px',
    display: 'flex',
};

const titleText = {
    color: '#FF5900', 
    fontSize: 20, 
    fontFamily: 'Courier Prime', 
    fontWeight: 'bold',
    flex: 1
};

const text = {
    color: 'white', 
    fontSize: 16, 
    fontFamily: 'Courier Prime', 
    flex: 1
};